import { createFileRoute, redirect } from '@tanstack/react-router';

import { queryClient } from '@/query/client';
import { checkAccessibilityPermissionsQueryOptions } from '@/query/permissions';
import { Routes } from '@/types/routes';
import { AppCapability, isCapable } from '@/utils/capabilities';

export const Route = createFileRoute('/accessibility')({
  staticData: { requiresAuth: true },
  beforeLoad: async ({ context, location }) => {
    await context.auth.requireAuth(location);
  },
  async loader() {
    if (!isCapable(AppCapability.DesktopMainWindowExclusive)) {
      throw redirect({
        to: Routes.Chats as string,
        replace: true,
      });
    }

    const hasAccessibilityPermissions = await queryClient.fetchQuery(
      checkAccessibilityPermissionsQueryOptions()
    );

    if (hasAccessibilityPermissions) {
      throw redirect({
        to: Routes.Chats as string,
        replace: true,
      });
    }
  },
});
